import { render, staticRenderFns } from "./BusinessJoin.vue?vue&type=template&id=59761804&scoped=true&"
import script from "./BusinessJoin.vue?vue&type=script&lang=js&"
export * from "./BusinessJoin.vue?vue&type=script&lang=js&"
import style0 from "./BusinessJoin.vue?vue&type=style&index=0&id=59761804&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59761804",
  null
  
)

export default component.exports